export const NONE_DEDUCTION = 0;
export const HALF_DEDUCTION = 1;
export const FULL_DEDUCTION = 2;
export const QUATER_DEDUCTION = 3;

export const DEDUCTION = {
  NONE_DEDUCTION: "全額個人負担",
  QUATER_DEDUCTION: "25%会社負担",
  HALF_DEDUCTION: "半額会社負担",
  FULL_DEDUCTION: "全額会社負担",
};
export const deducationList = [

  { id: NONE_DEDUCTION, name: DEDUCTION.NONE_DEDUCTION },
  { id: HALF_DEDUCTION, name: DEDUCTION.HALF_DEDUCTION },
  { id: FULL_DEDUCTION, name: DEDUCTION.FULL_DEDUCTION },
];

export const getDeduction = (deduction_id) => {
  return deducationList.find((deduction) => deduction.id === deduction_id);
};

// NONE_DEDUCTION: "全額給与控除", //全額個人負担
// HALF_DEDUCTION: "半額給与控除", //半額個人負担
// FULL_DEDUCTION: "給与控除無し", //全額会社負担
